<template>
  <BreadCrumb PageTitle="Stacks" />
  <StacksContant />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import StacksContant from "../../template-components/UIElements/Stacks/StacksContant.vue";

export default defineComponent({
  name: "StacksPage",
  components: {
    BreadCrumb,
    StacksContant,
  },
});
</script>